import { SelectedTime } from '../../ui/gzTimePicker/types';

export interface TimeFrame {
  start: SelectedTime;
  end: SelectedTime;
}

export enum PostponeRebootOptions {
  CUSTOM_TIME = 0,
  INTERVAL = 1,
  AFTER = 2,
}

export enum PostponeRebootMinutesOptions {
  TEN = 10,
  THIRTY = 30,
  FORTY_FIVE = 45,
  SIXTY = 60,
}
